import { District } from '@/apis/types'

export type MapWilayah = Record<string, District[]>

export const WILAYAH_NASIONAL: District = {
  id: '000000',
  parentId: '#',
  name: 'Indonesia',
  districtLevel: 0,
}

export const LOCATION_LEVEL = {
  0: 'Nasional',
  1: 'Provinsi',
  2: 'Kabupaten',
  3: 'Kecamatan',
}

export const isProvince = (district: District): boolean => {
  return district.districtLevel === 1
}

export const getAllProvince = (districts: District[]): District[] => {
  return districts ? districts.filter((item) => isProvince(item)) : []
}

export const getMapWilayahByParent = (districts: District[]): MapWilayah => {
  const a = {}
  districts.forEach((item) => {
    if (a[item.parentId]) {
      a[item.parentId].push(item)
    } else {
      a[item.parentId] = [item]
    }
  })

  return a
}
